import { Component } from '@angular/core';
import { ToastOptions, ToasterService } from '../../services/toaster.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent {
    constructor(public toaster: ToasterService) {}

    message: string;
    title: string;
    options: ToastOptions = {} as ToastOptions;

    get style(): {} {
        if (this.options == null) {
            return {
                top: '16px',
                right: '16px',
            };
        }
        return {
            top: this.options.vertical === 'top' ? '16px' : null,
            bottom: this.options.vertical === 'bottom' ? '16px' : null,
            right: this.options.horizontal === 'right' ? '16px' : null,
            left: this.options.horizontal === 'left' ? '16px' : null,
        };
    }
}
